import { css } from '@emotion/react'
import { Alert, Button, Heading, HFlow, VFlow } from 'bold-ui'
import { useHistory, useRouteMatch } from 'react-router-dom'

import type { AtendimentoIframe } from './SistemasExternosAtendimentoContext'

interface SistemasExternosAtendimentoListProps {
  items: ReadonlyArray<AtendimentoIframe>
}
export function SistemasExternosAtendimentoList(props: Readonly<SistemasExternosAtendimentoListProps>) {
  const match = useRouteMatch()
  const history = useHistory()
  const { items } = props

  return (
    <VFlow vSpacing={1} style={styles.verticalContainer}>
      <Alert type='info'>
        Os sistemas externos não possuem relação com o e-SUS APS. Em caso de problemas, contate o administrador da
        instalação.
      </Alert>
      <Heading level={3}>Selecione o sistema externo que deseja acessar</Heading>
      <HFlow hSpacing={1} style={styles.horizontalContainer}>
        {items.map((item) => (
          <Button
            style={styles.sistemasExternosButton}
            key={item.id}
            onClick={() => {
              history.push(`${match.url}/${item.id}`)
            }}
          >
            {item.nome}
          </Button>
        ))}
      </HFlow>
    </VFlow>
  )
}

const styles = {
  verticalContainer: css`
    height: max(calc(100vh - 24rem), 64rem);
  `,
  horizontalContainer: css`
    display: flex;
    flex-wrap: wrap;
  `,
  sistemasExternosButton: css`
    min-width: 16rem;
    margin: 0.25rem;
  `,
}
